<template>
  <div class="mail">
    <c-tab :tabs="tabs"></c-tab>
  </div>
</template>
<script>
import CTab from '@/components/common/tab'

export default {
  components: { CTab },
  data () {
    return {
      tabs: [ {
        label: '邮件列表',
        component: () => import('./#mail-list')
      }]
    }
  },
  created () {

  }
}
</script>
<style lang="scss" scoped>

</style>
